import { Box, CardInfo, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { companySize, reward } from '../helpers'

type Props = {
  step: string
  isoCountryCode: string
}

export const RewardCard = ({ step, isoCountryCode }: Props) => {
  return (
    <CardInfo>
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s12">
        <Text.Normal>
          {i18n.t('company_settings.general.factorial_referral_program.table_company_size', {
            size: companySize(step),
          })}
        </Text.Normal>
        <Icon.Medium icon="arrow-right" />
        <Tag type="radical" solid>
          {i18n.t('company_settings.general.factorial_referral_program.discount_tag', {
            reward: reward(isoCountryCode, step),
          })}
        </Tag>
      </Box>
    </CardInfo>
  )
}
